import React, { useState } from 'react'
import FormItem from '../../components/Form/FormItem';
import '../../index.css';
import '../../App.css';
import FaceBookLogIn from '../../components/Form/FaceBookLogIn'
import GoogleLogIn from '../../components/Form/GoogleLogIn';
import FormButton from '../../components/Form/FormButton';
import api from '../../services/api';

function FormLogin() {
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setErrors({}); // Réinitialiser les erreurs avant chaque tentative

    try {
      const res = await api.post('/login', {
        email: formData.email,
        password: formData.password,
      });

      console.log('Login response:', res);

      if (res.status === 200 || res.status === 201) {
        // Stocker le token JWT si renvoyé
        if (res.data.token) {
          localStorage.setItem('auth_token', res.data.token);
        }
        window.location.href = '/dashboard';
      }
    } catch (error) {
      console.error('Login error:', error);

      // Gestion spécifique des erreurs October CMS
      if (error.response?.data?.validation_errors) {
        setErrors(error.response.data.validation_errors);
      } else if (error.response?.data?.error) {
        setErrors({ general: error.response.data.error });
      } else if (error.response?.data?.message) {
        setErrors({ general: error.response.data.message });
      } else if (error.response?.data) {
        setErrors({ general: 'Erreur de connexion' });
      } else {
        setErrors({ general: 'Erreur de connexion au serveur' });
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });

    if (errors[name]) {
      setErrors({ ...errors, [name]: '' });
    }
    if (errors.general) {
      setErrors({ ...errors, general: '' });
    }
  };

  return (
    <div className=''>
      <h3 className="text-2xl md:text-3xl font-bold text-dark-1 dark:text-white">Se connecter</h3>
      <p className="mt-3 md:mt-5 text-gray-600 dark:text-gray-300 text-sm md:text-[15px]">
        Vous n'avez pas encore de compte ?
        <a href="https://app.gonextmaker.com/auth/signup" className="text-indigo-500 ml-1 hover:underline">Inscrivez-vous gratuitement.</a>
      </p>

      {errors.general && (
        <div className="mt-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded">
          {errors.general}
        </div>
      )}

      <form onSubmit={handleSubmit} className='mt-6 md:mt-8'>
        <div className='grid grid-cols-1 gap-4'>
          <FormItem
            name="Adresse mail"
            type="email"
            inputName="email"
            placeholder="email@exemple.com"
            value={formData.email}
            onChange={handleChange}
            error={errors.email}
          />
          <FormItem
            name="Mot de passe"
            type="password"
            inputName="password"
            placeholder="Mot de passe"
            value={formData.password}
            onChange={handleChange}
            error={errors.password}
          />
        </div>

        <div className='mt-6 md:mt-8'>
          <FormButton
            content={isLoading ? "Connexion..." : "Connecter"}
            disabled={isLoading}
          />
        </div>

        <p className='text-center text-dark-1 dark:text-white my-4 md:my-6 text-sm md:text-base'>
          Ou connectez-vous en utilisant
        </p>

        <div className='grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4'>
          <FaceBookLogIn />
          <GoogleLogIn />
        </div>
      </form>
    </div>
  )
}

export default FormLogin;